import { defineComponent as _defineComponent } from 'vue';
import Sidebar from "primevue/sidebar";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModelSidebar',
    props: {
        visible: Boolean,
        model: Object,
        modelName: String,
        female: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:visible"],
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const visible = ref(props.visible);
        const newLabelMale = 'Nuovo';
        const newLabelFemale = 'Nuova';
        const newLabel = props.female ? newLabelFemale : newLabelMale;
        const __returned__ = { props, visible, newLabelMale, newLabelFemale, newLabel, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
